import { george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import * as moment from "moment";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString, amountToNumber } from "types/amount";
import { ISIdDevice } from "types/ebvSecapp";
import { observable } from "../../../../node_modules/mobx";
import { GeorgeIdBanner } from "../components/GeorgeIdBanner";
import { SectionHeader } from "../components/SectionHeader";
import { Settings } from "../components/Settings";
import { SettingsButton } from "../components/SettingsButton";
import { SettingsButtonIcon } from "../components/SettingsButtonIcon";
import { SettingsButtonsContainer } from "../components/SettingsButtonsContainer";
import { SigningMethodBanner } from "../components/SigningMethodBanner";
import { SIdentitySettingsDeleteConfirmationDialog } from "./SidentitySettingsDeleteConfirmationDialog";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";
import { safeWindowOpen } from "util/helpers";

type IProps = RouteComponentProps<{}> & {
    store: SIdentitySettingsStore
};

const MyDevices = observer((props: { store: SIdentitySettingsStore, onDeleteDevice: (device: ISIdDevice) => void, style?: React.CSSProperties }) => {
    // debug.log("devices in store", props.store.devices!);
    const devices = props.store.devices && props.store.devices.map((device: ISIdDevice, index: number) => {
        const isPhone = device.clientType === "iOS" || device.clientType === "Android" || device.clientType === "WindowsPhone";
        const icon = isPhone ? require("assets/phone.svg") : require("assets/computer.svg");

        return (
            <SettingsButton
                key={device.id}
                border={index > 0 ? "top" : "none"}
                borderRadius="none"
                icon={<SettingsButtonIcon src={icon} />}
            >
                <div style={{ flex: 1 }}>
                    <pr.P_14_CONTENT style={{ color: theme.customColors.georgeLightGrey }}>
                        {`${ui.__("sidentitySettings.activationDate")} ${moment(device.activationDate.substr(0, device.activationDate.length - 5)).format("DD.MM.YYYY")}`}
                    </pr.P_14_CONTENT>
                    <pr.P_16_TITLE style={{ color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{device.alias || device.clientDevice}</pr.P_16_TITLE>
                    {device.alias && <pr.P_14_CONTENT>{device.clientDevice}</pr.P_14_CONTENT>}
                </div>
                {props.store.devices && props.store.devices.length > 1 &&
                    <SettingsButtonIcon
                        src={require("assets/bin.svg")}
                        onClick={() => props.onDeleteDevice(device)}
                        aria-label={ui.__("sidentitySettings.deleteDevice.confirm.title")}
                    />
                }
            </SettingsButton>
        );
    });

    return (
        <SettingsButtonsContainer style={props.style}>
            <SettingsButton border="bottom" borderRadius="top" variant="dense">
                <pr.P_18_TITLE style={{ fontWeight: 700 }}>
                    {ui.__("sidentitySettings.activatedDevices")}
                </pr.P_18_TITLE>
            </SettingsButton>
            {devices}
            <SettingsButton
                border={devices && devices.length > 0 ? "top" : "none"}
                borderRadius="bottom"
                onClick={() => {
                    if (props.store.status?.secAppVariant === "DUAL") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DEVICE_CATEGORY);
                    } else if (props.store.status?.secAppVariant === "DESKTOP") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DESKTOP_DEVICE_INFO);
                    } else if (props.store.status?.secAppVariant === "APP") {
                        pushRoute(SIdentitySettingsRoutes.ADD_DEVICE_SUMMARY);
                    }
                }}
                icon={<SettingsButtonIcon src={require("assets/plus.svg")} />}
            >
                <pr.P_16_TITLE style={{ flex: 1, color: ui.isDarkMode ? "white" : "#0A285C", fontWeight: 500 }}>{ui.__("sidentitySettings.addDevice")}</pr.P_16_TITLE>
                <pr.IconChevronRight style={{ color: "#A7B6C7" }} />
            </SettingsButton>
        </SettingsButtonsContainer>
    );
});

@observer
export class SIdentitySettingsHomeScreen extends React.Component<IProps, {}> {
    @observable showConfirmDeleteDialog = false;

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onClickGeorgeIdBanner = () => {
        safeWindowOpen("georgeapp://gid_migration");
    }

    onDeleteDevice = (device: ISIdDevice) => {
        ui.isPopupVisible = true;
        this.props.store.deviceToDelete = device;
        this.showConfirmDeleteDialog = true;
    }

    onConfirmDeleteDevice = async (deleteDevice?: boolean) => {
        this.showConfirmDeleteDialog = false;
        ui.isPopupVisible = false;
        if (deleteDevice && this.props.store.deviceToDelete) {
            try {
                await this.props.store.deleteSIdSettingsDevice();
                pushRoute(SIdentitySettingsRoutes.DELETE_SIGNING);
            } catch (err) {
                pushRoute("/error");
            }
        }
    }

    render() {
        const authorizationType = externalInterfaceStore.settings?.authorizationType;
        const sIdentityActive = authorizationType === "SID";

        let limit = ui.__("sidentity.limit.none");
        if (this.props.store.status
            && this.props.store.status.secAppDailyLimit
            && amountToNumber(this.props.store.status.secAppDailyLimit) > 0
        ) {
            limit = amountToCurrencyString(this.props.store.status.secAppDailyLimit);
        }

        return (
            <>
                <george.Background style={{ padding: 16 }}>
                    <george.LoadingIndicator isLoading={this.props.store.isLoading()} height={ui.windowHeight} />
                    {!this.props.store.isLoading() && (
                        <>
                            {this.props.store.canActivateGeorgeId && externalInterfaceStore.isGeorgeApp && (
                                <GeorgeIdBanner onClick={this.onClickGeorgeIdBanner} style={{ marginTop: 16, marginBottom: 32 }} />
                            )}
                            <SectionHeader>{ui.__("sidentitySettings.signingMethod")}</SectionHeader>
                            <SigningMethodBanner>
                                <FormattedHTMLMessage id="sidentitySettings.signingMethod.sIdentity" />
                            </SigningMethodBanner>
                            <Settings
                                store={this.props.store.aliasStore}
                                limit={limit}
                                limitManagementRoute={SIdentitySettingsRoutes.LIMIT}
                                showLimit={sIdentityActive}
                                style={{ marginTop: 16 }}
                            />
                            {sIdentityActive && (
                                <MyDevices store={this.props.store} onDeleteDevice={this.onDeleteDevice} style={{ marginTop: 16 }} />
                            )}
                        </>
                    )}
                </george.Background>
                <SIdentitySettingsDeleteConfirmationDialog
                    show={this.showConfirmDeleteDialog}
                    onClose={this.onConfirmDeleteDevice}
                />
            </>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsHomeScreen.tsx